import { $applyNodeReplacement, DecoratorNode } from "lexical";
import TargetAcheivedStars from "../../../components/TargetAcheivedStars";

export class TargetAcheivedStarsNode extends DecoratorNode<JSX.Element> {
  label: string | any;
  acheived: any;
  static getType() {
    return "targetAcheivedStars";
  }

  static clone(node:any) {
    return new TargetAcheivedStarsNode(node.label, node.acheived);
  }

  constructor(label:any, acheived:any, key?:any) {
    super(key);
    this.label = label;
    this.acheived = acheived;
  }

  createDOM() {
    const div = document.createElement("div");
    div.style.display = "inline-block";
    div.style.padding = "5px";
    div.style.border = "1px solid #ccc";
    div.style.margin = "10px 0";
    return div;
  }

  updateDOM() {
    return false;
  }

  decorate() {
    return <TargetAcheivedStars label={this.label} acheived={this.acheived} />;
  }
}

export function $targetAcheivedStarNode(
    label = '',
    acheived = 0
): TargetAcheivedStarsNode {
  const node = new TargetAcheivedStarsNode(label, acheived);
  return $applyNodeReplacement(node);
}